import Basic from "./Basic";
import Floating from "./Floating";
import Upload from "./Upload";

export default {
  Basic,
  Floating,
  Upload
};
